import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';

import MainBanner from '../../../components/MainBanner';
import ImageWithTextWithCardPadding from '../../../components/ImageWithTextWithCardPadding';

export default function FeaturedEmployersPage({
    global,
    all_featured_employers
}) {

    return (
        <>
            <SeoHead
                page_name={`Featured Employers | Staffing Agency | US and Canada Staffing | Bartech Staffing`}
                canonical_link={`job-seekers/featured-employers`}
            />
            <MainBanner
                global={global}
                pathPrefix={`job_seekers.featured_employers_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Featured Employers</h1>
                    </>
                }
                imageURL1={`/site-assets/images/featured-employers-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
            />
            <ImageWithTextWithCardPadding
                global={global}
                pathPrefix={`job_seekers.featured_employers_page.image_with_text_with_card_padding`}
                customClass={`py-5 grayGradientBg`}
                content={
                    <>
                        <h2>Want to be featured as an Employer?</h2>
                        <p>At Lorien, we support world-leading organisations in taking their technology above and beyond their competitors. Likewise, we encourage talented candidates to take the next step in their career with our bespoke service that offers candidates unique roles with high-profile employers that are exclusively partnered with Lorien. Candidates can browse through the roles to see what best aligns with their desired career path and ambitions on each business page.</p>
                    </>
                }
                buttonLink={``}
                buttonTitle={``}
                post_button_url_slug={true}
                post={all_featured_employers}
                previewImage={true}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const featured_employers = await Collection('featured_employers');

    const all_featured_employers = featured_employers.orderBy('_order').getItems();
    return {

        props: {
            global,
            all_featured_employers
        }

    }
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext